<div class="header">
    <div class="g-section-container">
        <div class="logo-container" (click)="goToHome()">
            <img src="assets/icons/Avenir-Energy-Logo-side-white.svg">
        </div>
        @if(isLoggedIn) {
        <div class="right-options">
            <div class="l-group">
                <avenir-header-accounting-period></avenir-header-accounting-period>
            </div>
            <div class="l-group">
                <avenir-header-reminder></avenir-header-reminder>
            </div>
            <div class="l-group">
                <div class="user-menu">
                    <avenir-header-user-menu [clientId]="clientId"></avenir-header-user-menu>
                </div>
            </div>
        </div>
        }
    </div>
</div>